<template>
  <div>
    <div v-if="loading" class="documents-by-section">
      <h2 v-if="language === 'ES'">Cargando documentos</h2>
      <h2 v-else>Loading documents</h2>
    </div>

    <div v-else>
      <div v-if="documents.length > 0" class="documents-by-section">
        <h2 v-if="language === 'ES'" class="title-documents">Documentos</h2>
        <h2 v-else class="title-documents">Documents</h2>
        <ul>
          <li
            v-for="document in documents"
            :key="document.id"
            class="document-item"
          >
            <div class="document-content">
              <span
                class="link-item"
                @click="checkDocument(baseUrl + document.file_path)"
              >
                {{ truncateFileName(document.file_name) }}
              </span>
              <v-icon class="document-icon" color="black">mdi-file</v-icon>
            </div>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import { showErrorToast } from "@/kernel/alerts";
import { getPublicFiles } from "../services/public-services";
import { getLanguage, BASEURL } from "@/kernel/utils";

export default {
  name: "DocumentsBySection",
  props: {
    sectionName: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      documents: [],
      loading: false,
      language: getLanguage(),
      baseUrl: BASEURL,
    };
  },
  mounted() {
    this.fetchDocuments();
  },
  methods: {
    truncateFileName(name) {
      return name.length > 60 ? name.substring(0, 57) + "..." : name;
    },
    async fetchDocuments() {
      this.loading = true;
      try {
        const response = await getPublicFiles(this.sectionName);
        if (response.status === 200) {
          if (response.data.content !== null) {
            this.documents = response.data.content;
          }
        }
      } catch (error) {
        console.error("Error fetching documents:", error);
      } finally {
        this.loading = false;
      }
    },
    async checkDocument(link) {
      try {
        const response = await fetch(link, { method: "HEAD" });
        if (response.ok) {
          window.open(link, "_blank");
        } else {
          if (this.language === "ES") {
            showErrorToast("El documento no existe");
          } else {
            showErrorToast("The document does not exist");
          }
        }
      } catch (error) {
        console.error("Error checking document:", error);
      }
    },
  },
};
</script>

<style scoped>
.documents-by-section {
  padding-left: 132px;
  padding-right: 132px;
  padding-top: 20px;
  padding-bottom: 20px;
  background-color: #f0efeb;
}

@media (max-width: 768px) {
  .documents-by-section {
    padding-left: 40px;
    padding-right: 40px;
  }
}

.document-item {
  background-color: whitesmoke;
  border-radius: 16px;
  padding: 16px;
}

.document-item:hover {
  background-color: #f8d0cf;
  transition: all 0.3s ease;
  cursor: pointer;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
  transform: scale(1.02);
}

.document-content {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.link-item {
  text-decoration: none;
  color: black;
  font-weight: bold;
  flex: 1;
  margin-right: 8px;
}

.document-icon {
  flex-shrink: 0;
}

.title-documents {
  font-size: 24px;
  margin-bottom: 16px;
}

ul {
  display: grid;
  gap: 16px;
  padding: 0;
  list-style: none;
  grid-template-columns: 1fr;
}

@media (min-width: 600px) {
  ul {
    grid-template-columns: repeat(2, 1fr);
  }
}

@media (min-width: 900px) {
  ul {
    grid-template-columns: repeat(3, 1fr);
  }
}
</style>
